



















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BottomFooter extends Vue {
  public emojis: string[] = [
    '(*￣∇￣*)',
    'ㄟ(▔,▔)ㄏ',
    '(～o￣3￣)～',
    '(;´▽`)y-~~',
    'ヾ(=･ω･=)o',
    'ﾍ|･∀･|ﾉ*~●',
    '(๑•̀ㅂ•́)و✧',
    'ヽ(°▽、°)ﾉ',
    'O(∩_∩)O',
    '(*≧∪≦)',
  ];

  public emoji: string = '';

  public randomEmoji() {
    this.emoji = this.emojis[Math.floor(Math.random() * this.emojis.length)];
  }

  public mounted() {
    this.randomEmoji();
    window.addEventListener('visibilitychange', this.randomEmoji);
  }

  public beforeDestroy() {
    window.removeEventListener('visibilitychange', this.randomEmoji);
  }
}
